// Sync with RoR constants
export const ADVISOR_SEARCH_PROMOTED_LOCATIONS: string[] = [
  "Aachen",
  "Augsburg",
  "Bad Säckingen",
  "Berlin",
  "Bielefeld",
  "Bochum",
  "Bonn",
  "Braunschweig",
  "Bremen",
  "Chemnitz",
  "Delmenhorst",
  "Dortmund",
  "Dresden",
  "Duisburg",
  "Düsseldorf",
  "Erfurt",
  "Essen",
  "Falkensee",
  "Fellbach",
  "Frankfurt",
  "Frankfurt am Main",
  "Freiburg",
  "Freiburg im Breisgau",
  "Gelsenkirchen",
  "Grevenbroich",
  "Hagen",
  "Halle",
  "Hamburg",
  "Hamm",
  "Hannover",
  "Herford",
  "Ingolstadt",
  "Karlsruhe",
  "Kassel",
  "Kerpen",
  "Kiel",
  "Köln",
  "Krefeld",
  "Leipzig",
  "Leonberg",
  "Leverkusen",
  "Lichtenfels",
  "Lörrach",
  "Lübeck",
  "Ludwigsburg",
  "Ludwigshafen",
  "Ludwigshafen am Rhein",
  "Magdeburg",
  "Mainz",
  "Mannheim",
  "Marburg",
  "Mönchengladbach",
  "Mülheim",
  "Mülheim an der Ruhr",
  "München",
  "Münster",
  "Nürnberg",
  "Oberhausen",
  "Oldenburg",
  "Osnabrück",
  "Potsdam",
  "Regensburg",
  "Rostock",
  "Saarbrücken",
  "Schweinfurt",
  "Sindelfingen",
  "Sinsheim",
  "Solingen",
  "Stuttgart",
  "Wiesbaden",
  "Wolfsburg",
  "Wuppertal",
];
